export function initHeader() {
    const $html = $('html');
    const $menu = $('#menu_block');
    const $flatInfo = $('.flat-info');
    const $hidedLinksDesktopWrapper = $('#hidden_links_wrapper');
    const openMenuClass = 'menu-block-open';
    const closeMenuClass = 'menu-block-closed';
    const $menuList = $('.menu-list');

    let isOpen = false;
    let scrollTop = window.scrollY;

    init();

    function init(){
        //тоггл меню мобилка
        $('body').on('click', '.menu-toggle-button', function () {
            toggleMobileMenu();

            return false;
        });



    }

    function toggleMobileMenu() {
        openCloseMenu();

        if (isOpen) {
            scrollTop = window.scrollY
        } else {
            window.scrollTo(0, scrollTop)
        }
    }

    function openCloseMenu() {
        const menuListHeight = $menuList.height();
        if (!$html.hasClass(openMenuClass)
            && !$html.hasClass(closeMenuClass)) {

            $menu.css('z-index', '901');
            //$menu.animate({height: menuListHeight}, 300);
            setTimeout(() => {
                if($flatInfo.length){
                    $flatInfo.hide();
                }
                $html.addClass(openMenuClass);
            }, 200)

        } else if ($html.hasClass(openMenuClass)
            && !$html.hasClass(closeMenuClass)) {

            //закрываем все раскрытые подменю

            $html.addClass(closeMenuClass);
            if($flatInfo.length){
                $flatInfo.show();
            }
            setTimeout(() => {
                $html.removeClass(openMenuClass);
                $menu.css('z-index', '-1');
                // $menu.animate({height: 0}, 300);
                $html.removeClass(closeMenuClass);
            }, 500)

        }
        isOpen = !isOpen;
    }
}